import { SentFaxUiStatus } from "@/Common/Models/UI/SentFaxUiStatus";
import { Icon } from "@/DesignSystem";
import { statusIconAndColors } from "./FaxStatusIconButton";

interface ISentFaxIconProps {
    status: SentFaxUiStatus;
}

function SentFaxIcon(props: ISentFaxIconProps): JSX.Element {
    const iconProps = statusIconAndColors[props.status];

    return iconProps
        ? (
            <Icon colorVariant={iconProps.variant} size="sm">
                {iconProps.icon}
            </Icon>
        )
        : null;
}

export { SentFaxIcon };
